import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useResourceSelectorContext } from "../../../../components/ResourceSelector/ResourceSelector";
import { getProjectName } from "../../../../ducks/project/selectors";
import { BarBlock, BlankContent } from "./styled";

import { ActionButton } from "./ActionButton";
import { FiltersAndSorts } from "./FiltersAndSorts";
import { SelectedResources } from "../SelectedResources/SelectedResources";
import { getAnySelected } from "../../../../ducks/catalog/selectors";

export const TopBar: FC = () => {
  const someSelected = useSelector(getAnySelected);
  const currentProject = useSelector(getProjectName);
  const { active: resourceSelectorActive } = useResourceSelectorContext();

  return (
    <BlankContent dialogStyled={!!currentProject}>
      <BarBlock>
        {someSelected ? (
          <SelectedResources />
        ) : (
          <>
            <FiltersAndSorts />
            {!resourceSelectorActive && <ActionButton />}
          </>
        )}
      </BarBlock>
    </BlankContent>
  );
};
